<template>
  <div v-if="loaded">
    <div class="row q-mb-md">
      <div class="col-md-12 col-sm-12 col-xs-12">
        <div class="card-block" v-if="nodes.length">
          <div class="row">
            <div class="col-md-2 q-pr-md">
              <!-- name -->
              <q-field class="q-mb-md">
                <q-input type="text" v-model="structure.code" readonly float-label="Code">
                </q-input>
              </q-field>
            </div>
            <div class="col-md-4 q-pr-md">
              <!-- description -->
              <q-field>
                <q-input
                  type="text"
                  v-model="structure.description"
                  readonly
                  :float-label="getString('description')"
                >
                </q-input>
              </q-field>
            </div>
            <!-- Cover upload -->
            <div class="col-md-5">
              <q-input
                clearable
                :readOnly="!edit"
                :disable="!edit"
                @clear="removeCover()"
                type="text"
                class="full-width q-mb-md"
                float-label="Cover"
                v-model="data.cover.name"
                @click="fileModal = true"
              />
            </div>

            <!-- Save / edit button -->
            <div class="col-md-1">
              <q-btn
                @click="save()"
                :color="edit ? 'primary' : 'grey-5'"
                class="capitalize ctrl-button right q-mt-lg"
                :icon-right="edit ? 'save' : 'edit'"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row gutter-sm">
      <!-- Left column -->
      <div class="col-md-4 col-sm-12 col-xs-12">
        <div class="card-block tree-block" v-if="nodes.length">
          <q-tree
            :nodes="nodes"
            accordion
            default-expand-all
            :selected.sync="selected"
            color="layout-aside-background"
            node-key="id"
            @lazy-load="onLazyLoad"
          />
        </div>
      </div>
      <div class="col">
        <div class="card-block">
          <!-- name -->
          <q-field class="q-mb-md">
            <q-input type="text" v-model="data.name" readonly :float-label="getString('name')">
            </q-input>
          </q-field>

          <!-- description -->
          <q-field class="q-mb-md">
            <q-input
              type="text"
              v-model="data.description"
              readonly
              :float-label="getString('description')"
            >
            </q-input>
          </q-field>

          <!-- Edit node -->
          <div class="row">
            <q-btn
              @click="$router.push(`/structure/${$route.params.structure}/node/${selected}`)"
              color="primary"
              class="capitalize ctrl-button right"
              :label="getString('action.edit')"
            />
          </div>
        </div>
      </div>
    </div>

    <!-- file select modal limited to pdf-->
    <q-modal v-if="fileModal" v-model="fileModal">
      <file-select-modal guid="cover" :extension="'pdf'" />
    </q-modal>
  </div>
</template>

<script>
import getString from '@/helpers/GetStrings';
import FileSelectModal from '@/components/modal/FileSelectModal.vue';
import EventBus from '@/event-bus';
import qs from 'qs';

export default {
  data() {
    return {
      edit: false,
      structure: '',
      selected: null,
      nodes: [],
      loaded: false,
      data: {},
      fileModal: false,
    };
  },
  components: {
    FileSelectModal,
  },
  methods: {
    getString,

    save() {
      if (!this.edit) {
        this.edit = true;
        return;
      }

      this.axios
        .put(`structure/${this.$route.params.structure}`, qs.stringify({
          cover: this.coverLocation,
        }))
        .then(() => {
          this.edit = false;
          this.$q.notify({
            message: this.getString(null, 'Saved successfully', 'Succesvol opgeslagen'),
            position: 'top-right',
            timeout: 1000,
            color: 'positive',
          });

        })
        .catch(err => {
          console.warn(err);
          this.$q.notify({
            message: this.getString(null, 'Something went wrong', 'Er is iets misgegaan'),
            position: 'top-right',
            timeout: 1000,
            color: 'negative',
          });
        });
    },

    removeCover() {
      this.data.cover = {
        location: '',
        name: '',
      };
    },

    // formats given nodes to the correct format for the tree.
    mapNodes(nodes) {
      return nodes.map(node => ({ id: node.id, label: node.name, lazy: node.hasChildren }));
    },

    // eslint-disable-next-line no-unused-vars
    onLazyLoad({ node, key, done, fail }) {
      if (node.lazy) {
        this.axios
          .get(`structure/${this.$route.params.structure}/node/${node.id}`)
          .then(res => {
            done(this.mapNodes(res.data.node.nodes.nodes));
          })
          .catch(err => {
            console.warn(err);

            // call fail() if any error occurs
            fail([]);
          });
      }
    },

    fetchNode(id) {
      this.axios
        .get(`structure/${this.$route.params.structure}/node/${id}`)
        .then(res => {
          this.data = res.data.node;
        })
        .catch(err => {
          console.warn(err);
        });
    },
  },

  watch: {
    selected() {
      if (!this.selected) {
        this.data = {};
      }
      this.fetchNode(this.selected);
    },
  },

  computed: {
    saveAction() {
      return this.edit ? this.getString('action.save') : this.getString('action.edit');
    },

    coverLocation() {
      return this.data.cover ? this.data.cover.location.replace('api/', '') : null;
    },
  },

  mounted() {
    if (this.$route.params && this.$route.params.structure) {
      this.axios
        .get(`structure/${this.$route.params.structure}`)
        .then(res => {
          this.structure = res.data.structure;
          this.nodes = res.data.structure.nodes && this.mapNodes(res.data.structure.nodes.nodes);

          this.data.cover = {
            location: this.structure.cover ? this.structure.cover.location : '',
            name: this.structure.cover ? this.structure.cover.name : '',
          };

          this.loaded = true;
        })
        .catch(err => {
          console.warn(err);
        });
    }

    EventBus.$on('file-select:cover', data => {
      if (data.type === 'image') {
        return;
      }

      this.data.cover = data;
      this.fileModal = false;
    });

    EventBus.$on('file-select-close', () => {
      this.fileModal = false;
    });
  },
};
</script>
